export default function (startTime) {
  let timeZone = new Date(startTime).getTimezoneOffset();

  let scheduleStartTime = new Date(startTime);

  scheduleStartTime.setMinutes(timeZone);

  if (startTime.split("T")) {
    if (new Date(scheduleStartTime).getHours() >= 12) return "Tarde";
    return "Manhã";
  }
}
